import httpClient from '@/api/httpClient'

class LocationApi {
  // fixnakanishi 一回につき 100 個までしか投げれないので、分割して投げる機構を実装する必要あり

  // locations は配列
  // 新規追加 = id が null 以外、id プロパティがない場合
  // 変更 = id がある
  //   [
  //     { // 変更
  //       id: 1,
  //       name: '位置情報1',
  //       shapeType: 'point',
  //       shape: {
  //         latitude: 111,
  //         longitude: 111,
  //       },
  //       deleted: false,
  //       status: 'active',
  //     },
  // { // 新規追加
  //   id: null,
  //   name: '位置情報2',
  //   shapeType: 'point',
  //   shape: {
  //     latitude: 111,
  //     longitude: 111,
  //   },
  // },
  // { // 変更
  //   id: 3,
  //     deleted: true,
  // },
  // ]

  //
  static async postCustomLocations({ locationGroupId, locations }) {
    try {
      const res = await httpClient.post(
        `/location_group/custom_location_group/${locationGroupId}/custom_location`,
        locations,
      )
      return res.data
    } catch (e) {
      console.error(e)
      const error = new Error('保存に失敗しました。')
      throw error
    }
  }

  static async savePoiLocation(
    poiLocationGroupId,
    categoryId,
    conditions,
    administrativeDistrictType,
    area,
  ) {
    try {
      const res = await httpClient.post(
        `/location_group/poi_location_group/${poiLocationGroupId}/poi_location`,
        {
          categoryId,
          conditions,
          administrativeDistrictType,
          area,
        },
      )
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  }

  static async fetchLocationList(locationGroupId, locationGroupType) {
    try {
      const res = await httpClient.get(
        `/location_group/${locationGroupType}_group/${locationGroupId}/${locationGroupType}`,
      )
      return res.data
    } catch (e) {
      console.log(e)
    }
  }
}

export default LocationApi
